// extracted by css-extract-rspack-plugin
export default {"container":"standard-layout_container__PHvXo","content":"standard-layout_content__6-WMK"};